// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--growth/confluence-side-nav';

import { MessageFrontend as createMessageFrontendConfluenceCreateASpace } from '@post-office/browser--growth/confluence-create-a-space/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendConfluenceResurrectedUserWelcomeSidebarNudge } from '@post-office/browser--cc-flywheel-engagement/confluence-resurrected-user-welcome-sidebar-nudge/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendConfluenceSideNav1On1LoomNudge } from '@post-office/browser--growth-starburst/confluence-side-nav-1-on-1-loom-nudge/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendConfluenceSideNavCreateASpace } from '@post-office/browser--post-office-team/confluence-side-nav-create-a-space/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendConfluenceCreateWithRovoSideNavNudge } from '@post-office/browser--cc-flywheel-feature-discovery/confluence-create-with-rovo-side-nav-nudge/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendRovoExtensionInstallCtaLeftNav } from '@post-office/browser--rovo-expansion/rovo-extension-install-cta-left-nav/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendTwcSidenavBanner } from '@post-office/browser--growth-starburst/twc-sidenav-banner/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendTwcSidenavAABanner } from '@post-office/browser--growth-starburst/twc-sidenav-a-a-banner/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendConfluenceRovoOnboardingBanner } from '@post-office/browser--belugas/confluence-rovo-onboarding-banner/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendConfluence3PToolsNudgeBanner } from '@post-office/browser--cc-flywheel-activation/confluence-3p-tools-nudge-banner/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendRovoNonMauChatCtaJiraConfluenceLeftNav } from '@post-office/browser--rovo-expansion/rovo-non-mau-chat-cta-jira-confluence-left-nav/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendConfluenceAgentsMcpNudgeBanner } from '@post-office/browser--cc-migrations-tooling/confluence-agents-mcp-nudge-banner/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendTwcLoomMeetingNudgeSidenav } from '@post-office/browser--growth-starburst/twc-loom-meeting-nudge-sidenav/placements/in-app-v2/confluence-side-nav';
import { MessageFrontend as createMessageFrontendRecentDowngradeDiscount } from '@post-office/browser--growth-transmuters/recent-downgrade-discount/placements/in-app-v2/confluence-side-nav';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type PlacementFrontendProps } from '@post-office/browser--growth/confluence-side-nav';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendConfluenceCreateASpace({ messageTemplateId: 'confluence-create-a-space' }),
	createMessageFrontendConfluenceResurrectedUserWelcomeSidebarNudge({
		messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge',
	}),
	createMessageFrontendConfluenceSideNav1On1LoomNudge({
		messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge',
	}),
	createMessageFrontendConfluenceSideNavCreateASpace({
		messageTemplateId: 'confluence-side-nav-create-a-space',
	}),
	createMessageFrontendConfluenceCreateWithRovoSideNavNudge({
		messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge',
	}),
	createMessageFrontendRovoExtensionInstallCtaLeftNav({
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
	}),
	createMessageFrontendTwcSidenavBanner({ messageTemplateId: 'twc-sidenav-banner' }),
	createMessageFrontendTwcSidenavAABanner({ messageTemplateId: 'twc-sidenav-a-a-banner' }),
	createMessageFrontendConfluenceRovoOnboardingBanner({
		messageTemplateId: 'confluence-rovo-onboarding-banner',
	}),
	createMessageFrontendConfluence3PToolsNudgeBanner({
		messageTemplateId: 'confluence-3p-tools-nudge-banner',
	}),
	createMessageFrontendRovoNonMauChatCtaJiraConfluenceLeftNav({
		messageTemplateId: 'rovo-non-mau-chat-cta-jira-confluence-left-nav',
	}),
	createMessageFrontendConfluenceAgentsMcpNudgeBanner({
		messageTemplateId: 'confluence-agents-mcp-nudge-banner',
	}),
	createMessageFrontendTwcLoomMeetingNudgeSidenav({
		messageTemplateId: 'twc-loom-meeting-nudge-sidenav',
	}),
	createMessageFrontendRecentDowngradeDiscount({ messageTemplateId: 'recent-downgrade-discount' }),
];

export const RawPlacement: PlacementRendererStage<PlacementFrontendProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<PlacementFrontendProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<PlacementFrontendProps> = RawPlacement;
